<template>
  <div class="header-login">
    <v-flex>
      <v-dialog v-if='loggedIn' v-model='createDialog' max-width='500px'>
        <template v-slot:activator="{ on }">
          <v-btn v-on='on' color='blue' dark>NEW SESSION</v-btn>
        </template>
        <v-card>
          <v-card-title>
            <span class='headline'>Create Session</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field v-model='sessionName' label='Session Name' required></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field v-model='password' label='Password' type='password' required></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-select v-model='sessionType' :items='SESSION_TYPES' label='Session Type' autocomplete required></v-select>
                </v-flex>
                <v-flex xs12>
                  <v-checkbox v-model='spectatorMode' label='Allow Spectators'></v-checkbox>
                </v-flex>
                <v-flex xs12>
                  <v-checkbox v-model='isPrivate'>
                    <template v-slot:label>
                      Private Session
                      <h6>This won't show up on the homepage. To invite other users, you need to share the link.</h6>
                    </template>
                  </v-checkbox>
                </v-flex>
              </v-layout>
            </v-container>
            <!--<small>*indicates required field</small>-->
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color='blue darken-1' text @click.native='createDialog = false'>Close</v-btn>
            <v-btn color='blue darken-1' text @click.native='createDialog = false; createSession()'>Create</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-flex>
  </div>
</template>

<script>
import SessionsService from '@/services/SessionsService'

export default {
  name: 'header-login',
  data () {
    return {
      createDialog: false,

      sessionName: '',
      password: '',
      sessionType: '3x3',
      spectatorMode: false,
      isPrivate: false,

      SESSION_TYPES: ['3x3', '2x2', '4x4', '5x5', '6x6', '7x7', '3x3OH', '3BLD', 'Clock', 'Megaminx', 'Pyraminx', 'Skewb', 'Square-1']
    }
  },
  props: {
    loggedIn: Boolean,
    pageType: String // eg. dashboard, session, etc.
  },
  methods: {
    async createSession () {
      if (!this.validateCreateSessionInputs()) {
        return
      }
      if (!this.loggedIn) {
        alert('You must be logged in order to create a session')
        return
      }
      var response = await SessionsService.createSession({
        globalAuthToken: this.$store.state.globalAuthToken,
        creatorId: this.$store.state.solverId,
        sessionName: this.sessionName,
        creator: this.$store.state.solver,
        password: this.password,
        sessionType: this.sessionType,
        spectatorMode: this.spectatorMode,
        isPrivate: this.isPrivate,
      })
      if (response.data.success) {
        var newSession = response.data.session
        localStorage.setItem('globalAuthToken', this.$store.state.globalAuthToken)
        localStorage.setItem('globalSolver', this.$store.state.solver)
        localStorage.setItem('solverId:' + newSession._id, this.$store.state.solverId)
        localStorage.setItem('token:' + newSession._id, response.data.authToken)

        this.$router.push({ path: `/session/${newSession._id}` })
      } else {
        alert('Session creation failed: ' + response.data.error)
      }
    },
    // TODO: improve input validation (eg. no trailing spaces, only readable text, no html or xss)
    validateCreateSessionInputs () {
      if (this.sessionName === '') {
        alert('Session Name cannot be empty')
        return false
      }
      if (this.password === '') {
        alert('Password cannot be empty')
        return false
      }
      return true
    },
    updatedDialog (val) {
      if (val) {
        this.$emit('open-dialog')
      } else {
        this.$emit('close-dialog')
      }
    }
  },
  watch: {
    createDialog (val) {
      this.updatedDialog(val)
    }
  }
}
</script>

<style scoped>
.v-list__tile {
  height: auto;
}
</style>
